/* eslint-disable import/no-unused-modules */
import { getAnonymousId } from './getAnonymousId';
import { track } from './track';
import { SSR } from '../utilities';

const missingAnalytics = {
  track: () => undefined,
  identify: () => undefined,
  page: () => undefined,
  reset: () => undefined,
};

export const getAnalytics = () => {
  if (SSR) {
    return {
      analytics: missingAnalytics,
      track,
      anonymousId: '',
      segmentData: undefined,
      simpleUserTraits: {},
      simpleUserTraitsWithIntegrations: {},
    };
  }

  const anonymousId = getAnonymousId();
  const simpleUserTraits = window.segmentData
    ? {
        traits: {
          email: window.segmentData.email || undefined,
          firstName: window.segmentData.firstName || undefined,
          lastName: window.segmentData.lastName || undefined,
          phone: window.segmentData.phone || undefined,
        },
      }
    : undefined;

  const simpleUserTraitsWithIntegrations = {
    integrations: { Optimizely: { userId: anonymousId } },
    context: { ...simpleUserTraits },
  };

  return {
    analytics: window.analytics as Omit<typeof window.analytics, 'track'>,
    track,
    segmentData: window.segmentData,
    anonymousId,
    simpleUserTraits,
    simpleUserTraitsWithIntegrations,
  };
};
